import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core'
import { SuperInterceptor } from '../super-interceptor.service';
import { CurrencyService } from '../currency.service';
import { HeaderService } from '../header.service';
import { Cookie } from '../cookie.service';



/*import { HrefLang } from '../shared/angular2-hreflang';*/

///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>

@Injectable()
export class RootInterceptor extends SuperInterceptor {
    constructor(private router:Router,private translate: TranslateService, private cookie:Cookie,
        public currencyService:CurrencyService,public headerService:HeaderService, @Inject(PLATFORM_ID) private platformId: Object/*, private hlang:HrefLang*/) {
         super(router,cookie);
    };

    canActivate(prev: ActivatedRouteSnapshot, next: RouterStateSnapshot) {
        super.canActivate(prev,next);
        let lang = this.cookie.get()['language'];
        if(!this.checkValidLanguage(lang)){
            lang = this.checkValidLanguage(this.translate.getBrowserLang())?this.translate.getBrowserLang():'en';
        }
        
        this.translate.use(lang);
        this.router.navigate([`/${lang}/home`]);
        
       
        return false;
    }

    public checkValidLanguage(lang:string){
        if(lang == 'es' || lang == 'en' || lang == 'fr' || lang == 'it' || lang == 'de'){
            return true;
        }else{
            return false;
        }
    }
}